// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DetailSalpren_container__WzVnv {
  animation: DetailSalpren_init__dvjYg 0.5s;
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  margin-bottom: 30px;
}

.DetailSalpren_container__WzVnv .DetailSalpren_header__0A0Uu {
  animation: DetailSalpren_init__dvjYg 1.3s;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.DetailSalpren_container__WzVnv .DetailSalpren_header__0A0Uu .DetailSalpren_arrow__5-ayl {
  transition: 0.3s;
  border-radius: 100%;
}

.DetailSalpren_container__WzVnv .DetailSalpren_header__0A0Uu .DetailSalpren_arrow__5-ayl:hover {
  transition: 0.3s;
  scale: 1.1;
  filter: brightness(1.2);
  background-color: rgba(128, 128, 128, 0.15);
  cursor: pointer;
}

.DetailSalpren_container__WzVnv .DetailSalpren_header__0A0Uu .DetailSalpren_titleContainer__93-zE {
  display: flex;
  justify-content: center;
  align-items: center;
}

.DetailSalpren_container__WzVnv .DetailSalpren_header__0A0Uu .DetailSalpren_titleContainer__93-zE h4 {
  font-size: 1.5rem;
  font-weight: 300;
  font-family: Roboto, sans-serif;
}

.DetailSalpren_container__WzVnv .DetailSalpren_header__0A0Uu .DetailSalpren_button__dd4-I {
  display: flex;
  justify-content: center;
  align-items: center;
}

.DetailSalpren_container__WzVnv .DetailSalpren_data__Hm36z .DetailSalpren_tableContainer__f0BKI {
  border-radius: 5px;
  max-height: 70vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

@keyframes DetailSalpren_init__dvjYg {
  0% {
    transform: translateY(10px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/ProcessFiles/MasivosSalpren/Detail/DetailSalpren.module.css"],"names":[],"mappings":"AAAA;EACE,yCAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yCAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,uBAAuB;EACvB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":[".container {\n  animation: init 0.5s;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  margin-bottom: 30px;\n}\n\n.container .header {\n  animation: init 1.3s;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.container .header .arrow {\n  transition: 0.3s;\n  border-radius: 100%;\n}\n\n.container .header .arrow:hover {\n  transition: 0.3s;\n  scale: 1.1;\n  filter: brightness(1.2);\n  background-color: rgba(128, 128, 128, 0.15);\n  cursor: pointer;\n}\n\n.container .header .titleContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.5rem;\n  font-weight: 300;\n  font-family: Roboto, sans-serif;\n}\n\n.container .header .button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .data .tableContainer {\n  border-radius: 5px;\n  max-height: 70vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n@keyframes init {\n  0% {\n    transform: translateY(10px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DetailSalpren_container__WzVnv`,
	"init": `DetailSalpren_init__dvjYg`,
	"header": `DetailSalpren_header__0A0Uu`,
	"arrow": `DetailSalpren_arrow__5-ayl`,
	"titleContainer": `DetailSalpren_titleContainer__93-zE`,
	"button": `DetailSalpren_button__dd4-I`,
	"data": `DetailSalpren_data__Hm36z`,
	"tableContainer": `DetailSalpren_tableContainer__f0BKI`
};
export default ___CSS_LOADER_EXPORT___;
